export const OMFS_CATEGORIES = [
  "Orthognathic",
  "TMJ",
  "Facial Plastics",
  "Oculoplastic Surgery",
  "Head/Oncology and Reconstruction Surgery",
  "Infection",
  "Trauma",
];

/**
 * Distinct colour palette per OMFS category. Tailwind-friendly classes for
 * background/border/text so chips stay legible in both light and dark shades.
 * Falls back to a neutral gray for null/legacy cases.
 */
export const OMFS_CATEGORY_STYLES = {
  Orthognathic: {
    bg: "bg-[#E8F1FB]",
    text: "text-[#1F4B7A]",
    border: "border-[#B7D1EA]",
    dot: "bg-[#3F84C7]",
  },
  TMJ: {
    bg: "bg-[#F1E9FB]",
    text: "text-[#4A2C7A]",
    border: "border-[#D3BFEA]",
    dot: "bg-[#7A47C7]",
  },
  "Facial Plastics": {
    bg: "bg-[#FCE8F1]",
    text: "text-[#7A1F4B]",
    border: "border-[#EABFD1]",
    dot: "bg-[#C74784]",
  },
  "Oculoplastic Surgery": {
    bg: "bg-[#FBE8CC]",
    text: "text-[#6B4100]",
    border: "border-[#F0C98A]",
    dot: "bg-[#B8700A]",
  },
  "Head/Oncology and Reconstruction Surgery": {
    bg: "bg-[#FFF3E0]",
    text: "text-[#7A3F00]",
    border: "border-[#F2CE9C]",
    dot: "bg-[#E58A2B]",
  },
  Infection: {
    bg: "bg-[#FDECEC]",
    text: "text-[#7A1F1F]",
    border: "border-[#F1BFBF]",
    dot: "bg-[#C74747]",
  },
  Trauma: {
    bg: "bg-[#FFF7DE]",
    text: "text-[#7A5B00]",
    border: "border-[#F1D97F]",
    dot: "bg-[#D9A400]",
  },
};

export const OMFS_NEUTRAL_STYLE = {
  bg: "bg-neu-muted/10",
  text: "text-neu-muted",
  border: "border-neu-muted/30",
  dot: "bg-neu-muted",
};

export function getOmfsStyle(category) {
  if (!category) return OMFS_NEUTRAL_STYLE;
  return OMFS_CATEGORY_STYLES[category] || OMFS_NEUTRAL_STYLE;
}
